module.exports = __webpack_public_path__ + "img/ico_login.fac3616f.svg";